export default __webpack_public_path__ + "static/media/logo.56dfc5c6.svg";